import React from 'react';
import { Paper, FontIcon } from 'material-ui';
import injectSheet from 'react-jss';
import R from 'ramda';
import { UpdateSummary, getPricingChangesComponent } from './section-updateSummary';

const styles = {
  a: {
    whiteSpace: 'wrap',
    fontWeight: '500',
    cursor: 'pointer'
  },
  leftNavContainer: { position: 'fixed', height: 'calc(100% + 96px)', paddingTop: '24px', overflowY: 'scroll', width: '30%' },
  overallRatesSummary: { fontSize: '12px', fontWeight: '400', textTransform: 'none', marginLeft: '12px', lineHeight: '24px' },
  pageSummaryHeader: { fontSize: '18px !important', color: 'white !important', cursor: 'pointer', textTransform: 'uppercase' },
  ratePackagePricingSummary: { fontSize: '12px', fontWeight: '400', textTransform: 'none', marginLeft: '12px', lineHeight: '24px', marginBottom: '8px' },
};
class DiffingLeftNav extends React.Component {
  render() {
    const { navItems, classes, locationName, supplierName, ratesSummary, productType, scrollToFunc, anchorId, highlightedHeader } = this.props;
    const { a, leftNavContainer, overallRatesSummary, pageSummaryHeader, ratePackagePricingSummary } = classes;
    const isComparingVersions = !Boolean(ratesSummary && !R.isEmpty(ratesSummary));
    /* Main Structure
    {
      ratesSummary: { nettAmountDiff, nettPercentDiff, extraAmountDiff, extraPercentDiff }
      navItems: [{
       mainType: 'policyNotes' OR 'ratePackage'
       header: 'Policies & Notes' OR <Product Name + Rate Package Name>
       nettAmountDiff
       nettPercentDiff
       extraAmountDiff
       extraPercentDiff
       pageSections: [{
        label: 'Updated Peak/High Season',
        updateSummary: [{
          text: 'Updated Dates',
        }, {
          text: 'Nightly - Saturday',
          subLabels: [{
            text: 'Pricing Changed',
            nettRate: { amounts: [20, 21, 20], percents: [8, 9, 8] }
          }, {
            text: 'Days of Week',
          }]
        }]
       }]
     }]
    }
     */
    return (
      <Paper id="diffingLeftNav" className={`settings-left-nav ${leftNavContainer}`} >
        <div
          className="settings-left-nav-inner settings-left-nav-heading"
          style={{ marginTop: '74px', backgroundColor: '#00bcd4', minHeight: '48px' }}
        >
          <span style={{ fontSize: '16px', fontWeight: '400', color: 'white', display: 'inline-block', lineHeight: '32px' }}>
            {supplierName === locationName ? locationName : `${supplierName ? `${supplierName} - ` : ''}${locationName}`}
          </span>
        </div>
        {
          !isComparingVersions && (
            <div style={{ padding: '8px' }}>
              <div className="flex-center" style={{ lineHeight: '24px', color: 'rgba(0, 0, 0, 0.54) !important', fontWeight: '400' }}>
                <FontIcon color="rgba(0, 0, 0, 0.54)" style={{ fontSize: '16px' }} className="tc-icon-info"/>
                &nbsp;Price Changed: {ratesSummary.nettAmountDiff || ratesSummary.extraAmountDiff ? '' : 'N/A'}
              </div>
              {
                Boolean(ratesSummary.nettAmountDiff || ratesSummary.extraAmountDiff) && (
                  <ul className={overallRatesSummary} style={{ paddingLeft: '8px' }}>
                    <li>
                      {productType === 'Accommodation' ? 'Room Types' : 'Products'}:&nbsp;
                      {ratesSummary.nettAmountDiff ? getPricingChangesComponent(ratesSummary.nettAmountDiff, ratesSummary.nettPercentDiff) : ': N/A'}
                    </li>
                    <li>
                      Extras:&nbsp;
                      {ratesSummary.extraAmountDiff ? getPricingChangesComponent(ratesSummary.extraAmountDiff, ratesSummary.extraPercentDiff) : ': N/A'}
                    </li>
                  </ul>
                )
              }
            </div>
          )
        }
        {
          navItems.map(({ mainType, addedOrRemoved, header, pageSections = [], ratePackageId, nettAmountDiff, nettPercentDiff, extraPercentDiff, extraAmountDiff }, navIndex) => (
            <div key={header} className="connections-widget" style={{ marginTop: navIndex ? '-8px' : '0' }}>
              <div
                className={`connections-widget-link ${pageSummaryHeader}`}
                style={{ backgroundColor: highlightedHeader === header ? '#464545' : 'rgba(0, 0, 0, 0.3)' }}
                onClick={() => scrollToFunc(header)}
              >
                <a className={a} style={{ color: 'white' }}>
                  {header}
                </a>
              </div>
              {
                mainType !== 'policyNotes' && Boolean(pageSections.length) && !isComparingVersions && !addedOrRemoved && (
                  <div style={{ padding: '4px', color: 'rgba(0, 0, 0, 0.54)' }}>
                    <div className="flex-center">
                      <FontIcon color="rgba(0, 0, 0, 0.54)" style={{ fontSize: '16px' }} className="tc-icon-info"/>
                      &nbsp;PRICE CHANGED: {nettAmountDiff || extraAmountDiff ? '' : 'N/A'}
                    </div>
                    {
                      Boolean(nettAmountDiff || extraAmountDiff) && (
                        <ul className={ratePackagePricingSummary} style={{ paddingLeft: '8px' }}>
                          <li>
                            {productType === 'Accommodation' ? 'Room Type: ' : 'Product: '}
                            {
                              nettAmountDiff ? getPricingChangesComponent(nettAmountDiff, nettPercentDiff) : 'N/A'
                            }
                          </li>
                          <li>
                            Extras:&nbsp;
                            {extraAmountDiff ? getPricingChangesComponent(extraAmountDiff, extraPercentDiff) : ': N/A'}
                          </li>
                        </ul>
                      )
                    }
                  </div>
                )
              }
                {
                  pageSections.map(({ type, label, updateSummary = [] }, subItemIndex) => {
                    const thisAnchor = `${ratePackageId || 'policyNotes'}${type}`;
                    const isActive = (anchorId && anchorId === thisAnchor) || (!anchorId && subItemIndex === 0 && navIndex === 0);
                    return (
                      <div
                        key={label}
                        id={`nav-${thisAnchor}`}
                        className={`connections-widget-link ${isActive ? 'is-active' : ''}`}
                        onClick={() => {
                          scrollToFunc(thisAnchor, header);
                        }}
                      >
                        <a className={a} style={{ color: isActive ? '#00bcd4' : 'rgba(0, 0, 0, 0.84)', fontSize: '14px' }}>
                          {label}
                          {
                            Boolean(updateSummary.length) && (
                              <UpdateSummary
                                updateSummary={updateSummary}
                              />
                            )
                          }
                        </a>
                      </div>
                    );
                  })
                }
            </div>
          ))
        }
      </Paper>
    )
  }
}

export default injectSheet(styles)(DiffingLeftNav);





// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/left-nav.jsx